<template>
  <div class="rule" :class="cssType">
    <div class="rule-title" :class="locale"></div>
    <div class="rule-content">
      <i18n-t keypath="accum.rule.content" tag="div" class="rule-content-i18n">
        <template #goRecharge>
          <button
            type="button"
            class="accum-link-yellow rule-go-recharge"
            @click="goRecharge"
          >
            [{{ $t('accum.goRecharge') }}]
          </button>
        </template>
      </i18n-t>
    </div>
  </div>
</template>

<script setup>
import { useRouter } from 'vue-router'
import { isMobile } from '@/utils'
import { useI18n } from 'vue-i18n'
import { useLog } from '@/composables/useLog'
const log = useLog()
const { locale } = useI18n()
const router = useRouter()
const cssType = isMobile ? 'mobile' : 'pc'

const goRecharge = () => {
  log.track('act_accum_recharge')
  const resolved = router.resolve({ name: 'Payment' })
  window.open(resolved.href, '_blank')
}
</script>

<style lang="less" scoped>
.rule-content-i18n {
  white-space: pre-line;
}
.rule-go-recharge {
  padding: 0;
  border: none;
  background: none;
  font: inherit;
  line-height: inherit;
  text-align: inherit;
  vertical-align: baseline;
}
</style>
<style lang="less" scoped src="./pc_style.less"></style>
<style lang="less" scoped src="./mobile_style.less"></style>
